import { render, staticRenderFns } from "./vip-choose.vue?vue&type=template&id=831d6468&scoped=true&"
import script from "./vip-choose.vue?vue&type=script&lang=js&"
export * from "./vip-choose.vue?vue&type=script&lang=js&"
import style0 from "./vip-choose.vue?vue&type=style&index=0&id=831d6468&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831d6468",
  null
  
)

export default component.exports